import { Button } from "common/Button";
import { CircleSpinner } from "common/spinners";
import { LoginModalOverlay } from "common/styleguide/LoginModalOverlay";
import { Msg } from "lib/localization";
import React from "react";
import { defineMessages } from "react-intl";
import Textarea from "react-textarea-autosize";
import styles from "./CommentBox.scss";

const messages = defineMessages({
  placeholder: {
    id: "CommentBox.placeholder",
    defaultMessage: "Write a comment...",
    description: "Placeholder text for a comment section",
  },
  post: {
    id: "CommentBox.post",
    defaultMessage: "Post",
    description: "A button to post a comment",
  },
});

export class CommentBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      showSignInModal: false,
      pending: false,
    };
  }

  handleSubmit = () => {
    if (this.state.comment === "") {
      return;
    }
    this.setState({ pending: true });
    this.props.onSubmit(this.state.comment).then(() => {
      this.setState({ pending: false, comment: "" });
    });
  };

  handleChange = (event) => {
    this.setState({ comment: event.target.value });
  };

  handleClick = () => {
    if (!this.props.loggedIn) {
      this.setState({ showSignInModal: true });
    }
  };

  hideSignInModal = () => {
    this.setState({ showSignInModal: false });
  };

  render() {
    const { loggedIn, placeholder, intl } = this.props;
    const { showSignInModal, pending, comment } = this.state;

    return (
      <div className={styles.CommentBox}>
        <Textarea
          disabled={pending}
          value={comment}
          placeholder={placeholder || intl.formatMessage(messages.placeholder)}
          onChange={this.handleChange}
          onClick={this.handleClick}
          className={styles.textarea}
        />
        {showSignInModal && <LoginModalOverlay onRequestClose={this.hideSignInModal} />}
        {loggedIn && (
          <Button className={styles.submitButton} type="default" onClick={this.handleSubmit}>
            <Msg m={messages.post} /> {pending && <CircleSpinner size={16} />}
          </Button>
        )}
      </div>
    );
  }
}
